<script>
import { FooterMenu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: []
      },
      singleton: true,
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nagłówek w prawej kolumnie',
          modelPath: [this, 'form', 'right_column_header'],
          multilingual: true
        }),
        new fields.Image({
          label: 'Zdjęcie w prawej kolumnie',
          modelPath: [this, 'form', 'right_column_image']
        }),
        new fields.Link({
          label: 'Link zdjęcia w prawej kolumnie',
          modelPath: [this, 'form', 'right_column_link'],
          hideLinkLabel: true
        }),
        new fields.Link({
          label: 'Link loga strony',
          modelPath: [this, 'form', 'logo_link'],
          hideLinkLabel: true
        }),
        new fields.Formset({
          modelPath: [this, 'form', 'items'],
          items: this.form.items.map((item, i) => {
            return {
              headerLabel: get(item, ['label_pl']),
              fields: [
                new fields.Link({
                  label: 'Link',
                  modelPath: [this, 'form', 'items', i]
                })
              ]
            }
          })
        })
      ]
    }
  },
  computed: {
    service() {
      return FooterMenu
    }
  }
}
</script>
